export enum ROOT_ID_PARAM_TYPE {
  REPORT_SCAN_ID = 'reportScanId',
  REQUEST_ID = 'requestId',
  CONTROL_MODEL_ID = 'controlModelId', // can be control ID or control (custom) model ID
  POLICY_MODEL_ID = 'policyModelId',
  RISK_ID = 'riskId', // can be risk ID or risk custom ID
  AUDITBOT_RUN_ID = 'auditRunId',
  SERVICE_ID = 'serviceId',
  RECEPTOR_ID = 'receptorId',
  VENDOR_ID = 'vendorId',
  EVIDENCE_ID = 'evidenceId',
  CHAT_ID = 'chatId',
  REPORT_ID = 'reportId',
  SCHEDULE_ID = 'scheduleId',
  FRAMEWORK_ID = 'frameworkId',
  USER_ROLE_ID = 'userRoleId',
  QUESTIONNAIRE_TEMPLATE_ID = 'questionnaireTemplateId',
}

// User roles are access roles; their index is a tab on the Users page rather than
// a page of its own, so INDEX carries the tab query param.
export enum UserRolesAbsoluteRoutes {
  ROOT = 'users/roles',
  INDEX = 'users?tab=user-role',
  SHOW = 'users/roles/show',
}

// User groups have no show page of their own -- they are edited from a modal on the
// Users page's groups tab -- so there is only an index to link to.
export enum UserGroupsAbsoluteRoutes {
  INDEX = 'users?tab=user-group',
}

export enum ControlsAbsoluteRoutes {
  ROOT = 'controls',
  INDEX = 'controls/index',
  INDEX_PAGE = 'controls/index?dismissed[]=false&contentSearch=true',
  SHOW = 'controls/show',
}

export enum ControlsSubRoutes {
  INDEX = 'index',
  SHOW = 'show',
}

export enum PoliciesAbsoluteRoutes {
  ROOT = 'policies',
  INDEX = 'policies/index',
  INDEX_PAGE = 'policies/index?dismissed[]=false&contentSearch=true',
  SHOW = 'policies/show',
}

export enum PoliciesSubRoutes {
  INDEX = 'index',
  SHOW = 'show',
}

export enum RisksAbsoluteRoutes {
  ROOT = 'risks',
  INDEX = 'risks/index',
  INDEX_PAGE = 'risks/index',
  SHOW = 'risks/show',
}

export enum ServicesAbsoluteRoutes {
  ROOT = 'services',
  SERVICES = 'services/services',
  RECEPTORS = 'services/receptors',
  INDEX = 'services/index',
  INDEX_PAGE = 'services/index',
  SHOW = 'services/show',
}

export enum ReceptorsAbsoluteRoutes {
  ROOT = 'receptors',
  INDEX = 'receptors/index',
  SHOW = 'receptors/show',
}

export enum FrameworksAbsoluteRoutes {
  ROOT = 'frameworks',
  INDEX = 'frameworks/index',
  SHOW = 'frameworks/show',
}

// Deprecated in favor of ExamineAndTestAbsoluteRoutes
// Keeping for redirect purposes
export enum AuditBotAbsoluteRoutes {
  ROOT = 'auditbot',
  INDEX = 'auditbot/index',
  INDEX_PAGE = 'auditbot/index',
  SHOW = 'auditbot/show',
}

export enum ExamineAndTestAbsoluteRoutes {
  ROOT = 'ai_examination_and_test',
  INDEX = 'ai_examination_and_test/index',
  INDEX_PAGE = 'ai_examination_and_test/index?page=1',
  SHOW = 'ai_examination_and_test/show',
  COMPLIANCE_ROOT = 'compliance_examination_and_test',
  COMPLIANCE_INDEX_PAGE = 'compliance_examination_and_test/index?page=1',
}

export enum RoadmapAbsoluteRoutes {
  ROOT = 'roadmap',
  INDEX = 'roadmap/index',
  INDEX_PAGE = 'roadmap/index',
  SHOW = 'roadmap/show',
}

// deprecated in favor of AiGrcQaAbsoluteRoutes
// keeping for redirect purposes
export enum SecurityQuestionnaireAbsoluteRoutes {
  ROOT = 'security_questionnaire',
  INDEX = 'security_questionnaire/index',
  SHOW = 'security_questionnaire/show',
}

export enum AiGrcQaAbsoluteRoutes {
  ROOT = 'ai_grc_qa',
  INDEX = 'ai_grc_qa/index',
}

export enum TrusteroIntelligenceAbsoluteRoutes {
  ROOT = 'trustero_intelligence',
  INDEX = 'trustero_intelligence/index',
  SHOW = 'trustero_intelligence/show',
}

export enum GrcDashboardsAbsoluteRoutes {
  ROOT = 'grc_dashboards',
  INDEX = 'grc_dashboards',
  SHOW = 'grc_dashboards',
}

export enum TrustPortalConfigurationAbsoluteRoutes {
  ROOT = 'trust_portal',
}

export enum VendorsAbsoluteRoutes {
  ROOT = 'vendors',
  INDEX = 'vendors/index',
  INDEX_PAGE = 'vendors/index',
  SHOW = 'vendors/show',
}

export enum EvidenceAbsoluteRoutes {
  ROOT = 'evidence',
  INDEX = 'evidence/index',
  INDEX_PAGE = 'evidence/index?page=1&contentSearch=true',
  SHOW = 'evidence/show',
  AUTOMATED_SCAN = 'evidence/automated_scan',
}

export enum RequestsAbsoluteRoutes {
  ROOT = 'requests',
  INDEX = 'requests/index',
  SHOW = 'requests/show',
}

export enum SubRoutes {
  INDEX = 'index',
  SHOW = 'show',
}

export enum ScopeAbsoluteRoutes {
  ROOT = 'scope',
}

export enum DirectRoutes {
  FEATURES = 'features',
  DASHBOARD = 'dashboard',
  BUYER_DASHBOARD = 'buyer_dashboard',
  GRC_DASHBOARDS = 'grc_dashboards',
  BUYER_REPORT = 'buyer_report',
  USERS = 'users',
  PROFILE = 'profile',
  COMPANY_INFO = 'company_info',
  ACCESS_DENIED = '/access_denied',
  AUDITS = 'audits',
  GENERIC_SIGNUP = 'signup',
  REPORT_SCAN_SIGNUP = 'scan_report',
  AI_SOC2_REPORT_SUMMARY_SIGNUP = 'ai_soc2_report_summary',
  SECURITY_QUESTIONNAIRE_SIGNUP = 'answer_questionnaire',
  AI_GRC_QA_SIGNUP = 'answer_grc_questions',
  SCOPE = 'scope',
  ACCOUNT_SETTINGS = 'account_settings',
  YOUR_PREFERENCE = 'your_preference',
  ACCOUNTS = 'accounts',
  MANAGE_DOCUMENTS = 'manage_documents',
  USAGE = 'usage',
  DOCUMENT_MANAGEMENT = 'document_management',
  GRC_PLATFORMS = 'grc_platforms',
  OIDC_EMAIL = 'oidc_email',
  INDEXING = 'indexing',
  WORKFLOW_MANAGEMENT = 'workflow_management',
  REPORTS = 'reports',
  INTEGRATIONS_LIST = 'integrations_list',
  PROMPT_OVERRIDES = 'prompt_overrides',
  PRODUCT_UPDATES = 'product_updates',
  INTERNAL_ACCOUNT_MANAGEMENT = 'internal_admin_panel',
  ACTIVITIES = 'activities',
  API_TOKENS = 'api_tokens',
}

export enum ReportsAbsoluteRoutes {
  INDEX_PAGE = 'reports/index?contentSearch=true',
}

// deprecated in favor of AiSoc2ReportSummaryAbsoluteRoutes
// keeping for redirect purposes
export enum ReportScanAbsoluteRoutes {
  ROOT = 'report_scan',
  INDEX = 'report_scan/index',
  SHOW = 'report_scan/show',
}

export enum AiSoc2ReportSummaryAbsoluteRoutes {
  ROOT = 'ai_soc2_report_summary',
  INDEX = 'ai_soc2_report_summary/index',
  SHOW = 'ai_soc2_report_summary/show',
  RISK_ROOT = 'risk_soc2_report_summary',
  RISK_INDEX = 'risk_soc2_report_summary/index',
}

export enum AccessManagementAbsoluteRoutes {
  ROOT = 'access_management',
  INDEX = 'access_management/index',
}

export enum SchedulingAbsoluteRoutes {
  ROOT = 'scheduling',
  INDEX = 'scheduling/index',
  SHOW = 'scheduling/show',
}
